import React from "react";
import "./Playlandmarks.css";


const playLandmarks = (props) => {
	
//   console.log(props.videoLandmarks);
  if ( props.videoLandmarks ) {
	  var canvas = document.querySelector("#unity-canvas");
	  if ( canvas ) {
		  document.querySelector('.plm_player').appendChild(canvas);
		  canvas.style.display = 'block';
		  
		  window.unityCall = function (status) {
			// console.log('Unity status', status);
		  }
		  
		  if ( window.unityInstance === undefined ) {
			  var config = {
					dataUrl: "Unity/Unity.data",
					frameworkUrl: "Unity/Unity.framework.js",
					codeUrl: "Unity/Unity.wasm",
					streamingAssetsUrl: "StreamingAssets",
					companyName: "DefaultCompany",
					productName: "VirdioChar",
					productVersion: "0.1",
					showBanner: null,
				  };
				
				window.createUnityInstance(canvas, config, (progress) => {}).then((unityInstance) => { setTimeout(() => { window.unityInstance = unityInstance; }, 5000); }).catch((message) => { });
				
				document.addEventListener('keydown', function(event) {
					switch(event.key) {
						case 'ArrowUp':
							window.unityInstance.SendMessage('Main Camera', 'moveCameraY', 0.1);
							break;
						case 'ArrowDown':
							window.unityInstance.SendMessage('Main Camera', 'moveCameraY', -0.1);
							break;
						case 'ArrowLeft':
							window.unityInstance.SendMessage('Main Camera', 'moveCameraX', 0.1);
							break;
						case 'ArrowRight':
							window.unityInstance.SendMessage('Main Camera', 'moveCameraX', -0.1);
							break;
						case 'Escape':
							window.unityInstance.SendMessage('Main Camera', 'cameraReset', '');
							break;
						default:
							// Other keys can be handled here if needed
							break;
					}
				});
				
				document.addEventListener('wheel', function(event) {
					if (event.deltaY < 0) {
						window.unityInstance.SendMessage('Main Camera', 'moveCameraZ', -0.1);
					} else if (event.deltaY > 0) {
						window.unityInstance.SendMessage('Main Camera', 'moveCameraZ', 0.1);
					}
				});

		  }
	  }
  }
  
  var intervall = false;
//   var playFrame = 0;
//   var mpList = window.mpLoad ? window.mpLoad : "";
  
//   var startTiming = 0;
//   var endTime = 0;
//   var playTiming = 0;
  
//   var lastDiff = 0;
  
  var isPlaying = false;
  const startPlay = () => {
	if ( isPlaying ) { return false; }
	
	isPlaying = true;
	
	document.querySelector('.plm_play_pause').className = 'plm_play_pause plm_play_pause_stop';
	
	if ( window.unityInstance && window.mpLoad ) {
		// console.log('Unity URL:', window.mpLoad);
		
		window.unityInstance.SendMessage('startPoint', 'SetAnchorLandmark', -1);
		window.unityInstance.SendMessage('startPoint', 'StartFromBrowser', window.mpLoad);
	}
	
	return false;
  };
  
  const closePopup = () => {
	if ( intervall ) { clearInterval(intervall); }
	var canvas = document.querySelector("#unity-canvas");
	canvas.style.display = 'none';
	document.body.appendChild(canvas);
	props.doClose();
  };
  
  
  const seekPlay = (e) => {
	  /*if ( document.getElementById('plm_progress_container') ) {
			var rect = document.getElementById('plm_progress_container').getBoundingClientRect();
		
			if ( startTiming == 0 && window.mpLoad && window.mpLoad[0] && window.mpLoad[0]['time'] ) {
				startTiming = window.mpLoad[0]['time'];
				endTime = window.mpLoad[window.mpLoad.length - 1]['time'];
			}
			
			var seekX = e.clientX - rect.left;
			var perc = seekX / rect.width;
			var timeM = mpList[Math.floor(mpList.length * perc)]['time'];
			lastDiff = timeM - startTiming;
			
			playTiming = new Date().getTime() - lastDiff;
		}*/
  }
  
  return (
    <div className="plm_top">
		<div className="plm_popup">
			<div className="plm_close" onClick={() => closePopup() }>&times;</div>
			<div className="plm_player"></div>
			
			<div id="mainprogress_unity" className="progress-bar">
				<div id="mainprogress_unity_text" className="reps_number_circural_progress"></div>
			</div>
			<div className="plm_controls">
				<div className="plm_play_pause" onClick={() => startPlay()}></div>
				<div className="plm_progress_container" id="plm_progress_container" onMouseDown={(e) => seekPlay(e)}>
					<div className="plm_progress" id="plm_progress"></div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default playLandmarks;
